import { useDispatch } from 'react-redux';
import { useForm } from 'antd/lib/form/Form';
import { useHistory } from 'react-router-dom';

import { useApplicationContext } from '@/context/Application';
import { setSession } from '@/redux/auth/actions';
import { useSignIn } from '@/hooks/useSignIn';
import { LoginForm } from './Form';
import type { FormData } from './types';
import type { SignInResponseDTO } from '@/core/dto/auth/sign-in';

export function Content() {
	const history = useHistory();
	const dispatch = useDispatch();
	const [form] = useForm<FormData>();
	const { setUser } = useApplicationContext();
	const { isLoading, mutateAsync, error } = useSignIn();

	function isTwoFactorAutenticatedValid(data: SignInResponseDTO): boolean {
		return data?.two_fa?.is_2fa_login_enabled && data?.two_fa?.validated;
	}

	function isForcedTwoFactorAutenticatedEnabled(data: SignInResponseDTO): boolean {
		return !!data.user.force_two_fa;
	}

	function handleCheckTwoFactorAuthenticationRedirect(userId: string): void {
		return history.push(`/check-two-factor/${userId}`);
	}

	function handleGenerateTwoFactorAuthenticationRedirect(userId: string): void {
		return history.push(`/generate-two-factor/${userId}`);
	}

	async function handleOnSubmit(values: FormData): Promise<void> {
		const data = await mutateAsync(values);

		const { user, token, refresh_token } = data;

		setUser({ user, token, refresh_token });

		if (isTwoFactorAutenticatedValid(data)) {
			return handleCheckTwoFactorAuthenticationRedirect(user.id);
		}

		if (isForcedTwoFactorAutenticatedEnabled(data)) {
			return handleGenerateTwoFactorAuthenticationRedirect(user.id);
		}

		dispatch(setSession({ user, token, refresh_token }));
		history.push('/');
	}

	return <LoginForm form={form} loading={isLoading} onFinish={handleOnSubmit} errors={error} />;
}
